angular.module('cfn').directive('modalDialog', function() {
  return {
    restrict: 'E',
    scope: {
      show: '=',
      modalTitle: '<'
    },
    replace: true, // Replace with the template below
    transclude: true, // we want to insert custom content inside the directive
    // controller: GenericModalController,
    link: function(scope, element, attrs) {
      scope.dialogStyle = {};
      if (attrs.width) scope.dialogStyle.width = attrs.width;
      if (attrs.height) scope.dialogStyle.height = attrs.height;
      scope.hideModal = function() {
        scope.show = false;
      };
    },
    template:
      "<div class='ng-modal' ng-show='show'><div class='ng-modal-overlay' ng-click='hideModal()'></div><div class='ng-modal-dialog' ng-style='dialogStyle'><div class='modal-header modal__header'><h3>{{modalTitle}}<h3><div class='ng-modal-close' ng-click='hideModal()'><span class='farmnet-cross'></span></div></div><div class='ng-modal-dialog-content' ng-transclude></div></div></div>"
  };
});

angular.module('cfn').controller('GenericModalController', [
  '$scope',
  function($scope) {
    // TODO: make this generic!
    // $scope.modalShown = false;
    // $scope.toggleModal = function () {
    //     $scope.modalShown = !$scope.modalShown;
    // };
  }
]);
